import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Paging } from '../../../model/paging/paging';
import { LicenseList } from '../../../model/license/license-list';


@Injectable({
    providedIn: 'root'
})
export class LicenseService_Mock {
    GETPaginatedLicenses(paging:Paging): Observable<LicenseList>  | any{
        const allData = [
            {
                licenseId: "license-1",
                licenseKey: "ABC123XYZ",
                generateDate: 1710912000,
                duration: 365,
                companyName: "Tech Solutions SRL",
                enabled: true
            },
            {
                licenseId: "license-2",
                licenseKey: "DEF456UVW",
                generateDate: 1710912100,
                duration: 180,
                companyName: "Innovatech SPA",
                enabled: false
            },
            {
                licenseId: "license-3",
                licenseKey: "GHI789RST",
                generateDate: 1711912100,
                duration: 730,
                companyName: "Green Energy SRL",
                enabled: true
            }
        ];     
        
        const start = (paging.pageIndex - 1) * paging.pageSize;
        const end = start + paging.pageSize;
        const pageData = allData.slice(start, end);

        const mockData = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 11,
            data: {
                count: allData.length,
                items: pageData
            }
        };

        return of(mockData);
    }

    PUTLicenseStatus(licenseId:string, body:LicenseList){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 8,
            data: true
        };

        return of(mockResponse);
    }

    DELETELicense(licenseId:string){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 7,
            data: true
        };

        return of(mockResponse);
    }   
}
